(function () {
  'use strict';

  // ─── Constants ─────────────────────────────────────────────────────────────

  var SESSION_KEY  = 'giftPlansState';
  var EMAIL_REGEX  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var ZIP_REGEX    = /^[0-9]{5}$/;

  // ZIP ↔ state coherence: valid 3-digit ZIP prefixes per state (inclusive ranges).
  // USPS assigns prefixes by state, so a ZIP outside its state's ranges can't be right.
  var ZIP_STATE_RANGES = {
    AL: [[350,369]], AK: [[995,999]], AZ: [[850,865]], AR: [[716,729]],
    CA: [[900,961]], CO: [[800,816]], CT: [[60,69]],   DE: [[197,199]],
    FL: [[320,349]], GA: [[300,319],[398,399]], HI: [[967,968]], ID: [[832,838]],
    IL: [[600,629]], IN: [[460,479]], IA: [[500,528]], KS: [[660,679]],
    KY: [[400,427]], LA: [[700,714]], ME: [[39,49]],   MD: [[206,219]],
    MA: [[10,27],[55,55]], MI: [[480,499]], MN: [[550,567]], MS: [[386,397]],
    MO: [[630,658]], MT: [[590,599]], NE: [[680,693]], NV: [[889,898]],
    NH: [[30,38]],   NJ: [[70,89]],   NM: [[870,884]], NY: [[5,5],[100,149]],
    NC: [[270,289]], ND: [[580,588]], OH: [[430,459]], OK: [[730,732],[734,749]],
    OR: [[970,979]], PA: [[150,196]], RI: [[28,29]],   SC: [[290,299]],
    SD: [[570,577]], TN: [[370,385]], TX: [[733,733],[750,799],[885,885]],
    UT: [[840,847]], VT: [[50,54],[56,59]], VA: [[201,201],[220,246]],
    WA: [[980,994]], WV: [[247,268]], WI: [[530,549]], WY: [[820,831]]
  };

  var ZIP_STATE_MESSAGE = 'This ZIP code doesn\'t match the selected state.';

  // Duration badge config
  // Grid-of-boxes artwork per box type (regular/pro/elite) and duration (months).
  var DURATION_IMAGES = {
    regular: {
      4:  'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/4_Boxes_Elite_C4A47C.webp?v=1784249894',
      6:  'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/6_Boxes_Elite_C4A47C.webp?v=1784249894',
      12: 'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/12_Boxes_Elite_C4A47C.webp?v=1784249894'
    },
    pro: {
      4:  'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/4_Boxes_Elite_Black.webp?v=1784249057',
      6:  'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/6_Boxes_Elite_Black.webp?v=1784249057',
      12: 'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/12_Boxes_Elite_Black_1.webp?v=1784249057'
    },
    elite: {
      4:  'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/4_Boxes_Elite.png?v=1782344476',
      6:  'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/6_Boxes_Elite.png?v=1782344476',
      12: 'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/12_Boxes_Elite.png?v=1782344476'
    }
  };

  // Same normalization as gift-box-card.liquid: metafield value → regular|pro|elite
  function getBoxKey(boxSize) {
    var bs = String(boxSize || '').toLowerCase();
    if (bs.indexOf('pro') !== -1) return 'pro';
    if (bs.indexOf('elite') !== -1) return 'elite';
    return 'regular';
  }

  var REQUIRED_FIELDS = [
    { domId: 'gp-recipient-name',    key: 'recipient_name',    message: 'Recipient name is required.' },
    { domId: 'gp-recipient-email',   key: 'recipient_email',   message: 'Please enter a valid email address.' },
    // The recipient's shipping address is entered once, in checkout (see the
    // gift-recipient-address checkout UI extension). Not collected here.
    { domId: 'gp-start-date',        key: 'start_date',        message: 'Please select a valid start date.' }
  ];

  var ALL_FIELDS = REQUIRED_FIELDS.concat([
    { domId: 'gp-email-date',   key: 'email_date' },
    { domId: 'gp-gift-message', key: 'gift_message' }
  ]);

  // ─── State ─────────────────────────────────────────────────────────────────

  var state = {
    boxSize:   null,  // key in GIFT_PLANS_DATA
    variantId: null,  // selected variant ID (species)
    duration:  null,  // months
    fields: {
      recipient_name:    '',
      recipient_email:   '',
      start_date:        '',
      gift_message:      ''
    }
  };

  // ─── DOM Refs ───────────────────────────────────────────────────────────────

  var submitBtn    = document.getElementById('gp-submit-btn');
  var submitError  = document.getElementById('gp-submit-error');
  var submitPrice  = document.getElementById('gp-submit-price');
  var charCount    = document.getElementById('gp-gift-message-count');
  var mainImage    = document.getElementById('gp-main-image');
  var thumbsWrap   = document.getElementById('gp-thumbs');
  var summaryEl    = document.getElementById('gp-summary');
  var summaryBox   = document.getElementById('gp-summary-box');
  var summaryDur   = document.getElementById('gp-summary-duration');
  var summarySub   = document.getElementById('gp-summary-subtotal');
  var summaryTotal = document.getElementById('gp-summary-total');

  // ─── Formatters ────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── Field Error UI ────────────────────────────────────────────────────────

  function showFieldError(domId, message) {
    var input = document.getElementById(domId);
    var error = document.getElementById('gp-error-' + domId.replace('gp-', ''));
    if (input) { input.classList.add('gift-input--error'); input.classList.add('gift-select--error'); input.classList.add('gift-textarea--error'); }
    if (error) error.textContent = message;
  }

  function clearFieldError(domId) {
    var input = document.getElementById(domId);
    var error = document.getElementById('gp-error-' + domId.replace('gp-', ''));
    if (input) { input.classList.remove('gift-input--error'); input.classList.remove('gift-select--error'); input.classList.remove('gift-textarea--error'); }
    if (error) error.textContent = '';
  }

  function clearAllFieldErrors() {
    ALL_FIELDS.forEach(function (f) { clearFieldError(f.domId); });
  }

  // ─── Step States ───────────────────────────────────────────────────────────

  // Browser autofill can populate inputs without firing per-field input events,
  // leaving state.fields stale. Re-read the DOM before computing readiness.
  function cleanEmail(raw) {
    var email = String(raw || '').trim().replace(/^mailto:/i, '');
    var angle = email.match(/<([^>]+)>/);
    if (angle) email = angle[1];
    return email.split('?')[0].trim().toLowerCase();
  }

  function syncFieldsFromDOM() {
    ALL_FIELDS.forEach(function (f) {
      var el = document.getElementById(f.domId);
      if (el && el.value !== state.fields[f.key]) state.fields[f.key] = el.value;
    });
  }

  function isRecipientReady() {
    return REQUIRED_FIELDS.every(function (f) {
      if (f.key === 'start_date') return true;
      return state.fields[f.key] && state.fields[f.key].trim() !== '';
    });
  }

  function updateStepStates() {
    syncFieldsFromDOM();
    var stepBox       = document.getElementById('gp-step-box');
    var stepSpecies   = document.getElementById('gp-step-species');
    var stepDuration  = document.getElementById('gp-step-duration');
    var stepRecipient = document.getElementById('gp-step-recipient');
    var stepDelivery  = document.getElementById('gp-step-delivery');
    if (!stepBox) return;

    var boxDone       = !!state.boxSize;
    var speciesDone   = !!state.variantId;
    var durDone       = !!state.duration;
    var recipientDone = isRecipientReady();
    var formDone      = isFormReady();

    // Step 1 — box
    stepBox.classList.toggle('is-active',   !boxDone);
    stepBox.classList.toggle('is-complete',  boxDone);
    stepBox.classList.remove('is-locked');

    // Step 2 — species
    if (stepSpecies) {
      stepSpecies.classList.toggle('is-locked',   !boxDone);
      stepSpecies.classList.toggle('is-active',    boxDone && !speciesDone);
      stepSpecies.classList.toggle('is-complete',  speciesDone);
    }

    // Step 3 — duration
    if (stepDuration) {
      stepDuration.classList.toggle('is-locked',  !speciesDone);
      stepDuration.classList.toggle('is-active',   speciesDone && !durDone);
      stepDuration.classList.toggle('is-complete', durDone);
    }

    // Step 4 — recipient
    if (stepRecipient) {
      stepRecipient.classList.toggle('is-locked',  !durDone);
      stepRecipient.classList.toggle('is-active',   durDone && !recipientDone);
      stepRecipient.classList.toggle('is-complete', durDone && recipientDone);
    }

    // Step 5 — gift delivery
    if (stepDelivery) {
      stepDelivery.classList.toggle('is-locked',  !recipientDone);
      stepDelivery.classList.toggle('is-active',   recipientDone && !formDone);
      stepDelivery.classList.toggle('is-complete', recipientDone && formDone);
    }
  }

  // ─── Summary ───────────────────────────────────────────────────────────────

  function updateSummary() {
    if (!summaryEl) return;

    if (!state.boxSize || !state.variantId || !state.duration) {
      summaryEl.setAttribute('hidden', '');
      return;
    }

    var product = window.GIFT_PLANS_DATA[state.boxSize];
    if (!product) return;

    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === state.variantId) { variant = product.variants[i]; break; }
    }
    if (!variant) return;

    // Price comes from the selected duration's product; the display variant
    // price (shortest duration) is only a fallback.
    var sel       = resolveSelection(state.boxSize, state.variantId, state.duration);
    var basePrice = sel ? sel.monthly : variant.price;
    var total     = basePrice * state.duration;

    if (summaryBox)   summaryBox.innerHTML   = '<span>' + (state.boxSize.charAt(0).toUpperCase() + state.boxSize.slice(1)) + ' Box · ' + variant.title + '</span><span>' + formatMoney(basePrice) + '/box</span>';
    if (summaryDur)   summaryDur.innerHTML   = '<span>Duration</span><span>' + state.duration + (state.duration === 1 ? ' box' : ' boxes') + '</span>';
    if (summarySub)   summarySub.innerHTML   = '<span>Subtotal</span><span>' + formatMoney(total) + '</span>';
    if (summaryTotal) summaryTotal.textContent = formatMoney(total);
    if (submitPrice)  submitPrice.textContent  = formatMoney(total);

    summaryEl.removeAttribute('hidden');
  }

  // ─── Gallery ───────────────────────────────────────────────────────────────

  // Normalize a raw box_size metafield value ("Elite", "PRO"…) to a stable key.
  function boxKeyOf(boxSize) {
    var s = (boxSize || '').toLowerCase();
    if (s.indexOf('pro') !== -1) return 'pro';
    if (s.indexOf('elite') !== -1) return 'elite';
    return 'regular';
  }

  // Find a custom editor gallery matching this level (box) + species (variant title).
  function findCustomGallery(boxSize, variantTitle) {
    var list = window.GIFT_PLANS_GALLERIES;
    if (!list || !list.length) return null;
    var bk = boxKeyOf(boxSize);
    var t  = (variantTitle || '').toLowerCase().trim();
    for (var i = 0; i < list.length; i++) {
      var g = list[i];
      if (!g.images || !g.images.length) continue;
      if (g.level !== bk) continue;
      var sp = (g.species || '').trim();
      if (!sp) continue;
      if (t === sp || t.indexOf(sp) !== -1 || sp.indexOf(t) !== -1) return g;
    }
    return null;
  }

  function updateGallery(boxSize, variantId) {
    if (!window.GIFT_PLANS_DATA || !boxSize) return;
    var product = window.GIFT_PLANS_DATA[boxSize];
    if (!product) return;

    var variant = null;
    if (variantId) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === variantId) { variant = product.variants[i]; break; }
      }
    }

    // Prefer a custom editor gallery for this level + species; else fall back
    // to the product/variant images.
    var custom = findCustomGallery(boxSize, variant ? variant.title : '');
    var images;
    if (custom && custom.images.length) {
      images = custom.images.slice();
    } else {
      images = (product.images && product.images.length)
        ? product.images.slice()
        : (product.image ? [product.image] : []);
      if (variant && variant.image) {
        images = [variant.image].concat(images.filter(function (s) { return s !== variant.image; }));
      }
    }

    if (mainImage && images[0]) mainImage.src = images[0];

    // Thumbnails
    if (thumbsWrap) {
      thumbsWrap.innerHTML = '';
      images.forEach(function (src, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gift-buy__thumb' + (idx === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'View photo ' + (idx + 1));
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        btn.appendChild(img);
        btn.addEventListener('click', function () {
          if (mainImage) mainImage.src = src;
          thumbsWrap.querySelectorAll('.gift-buy__thumb').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
        thumbsWrap.appendChild(btn);
      });
    }
  }

  // ─── Render Species Grid ───────────────────────────────────────────────────

  // Species metadata — matched by keyword in the variant (species) title.
  var SPECIES_META = [
    { match: ['bass'],                 img: 'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/bass_079e67ea-c25a-4aa2-bb91-3f21526a89aa.png?v=1782342580', popular: true, desc: 'Baits for targeting largemouth bass, smallmouth bass, and spotted bass' },
    { match: ['panfish', 'trout'],     img: 'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/Panfish_Trout.png?v=1782342580',                          desc: 'Baits for crappie, bluegill, perch, and stocked trout' },
    { match: ['inshore', 'saltwater'], img: 'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/inshore_saltwater.png?v=1782342580',                       desc: 'Baits for redfish, speckled trout, flounder, and other inshore species' },
    { match: ['multi'],                img: 'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/multispecies.png?v=1782342580',                            desc: 'A versatile mix of baits that performs across multiple freshwater species' },
    { match: ['walleye'],              img: 'https://cdn.shopify.com/s/files/1/0672/1794/8724/files/Walleye_ac7d79bc-7a32-4fad-926d-6b18a09318af.png?v=1782342580', desc: 'Baits for targeting walleye, sauger, and pike' }
  ];

  function speciesMetaFor(title) {
    var key = (title || '').toLowerCase();
    for (var i = 0; i < SPECIES_META.length; i++) {
      for (var j = 0; j < SPECIES_META[i].match.length; j++) {
        if (key.indexOf(SPECIES_META[i].match[j]) !== -1) return SPECIES_META[i];
      }
    }
    return null;
  }

  function renderSpeciesGrid(boxSize) {
    var grid = document.getElementById('gp-species-grid');
    if (!grid) return;
    grid.innerHTML = '';

    if (!window.GIFT_PLANS_DATA || !boxSize) return;
    var product = window.GIFT_PLANS_DATA[boxSize];
    if (!product || !product.variants || !product.variants.length) return;

    product.variants.forEach(function (variant) {
      var meta    = speciesMetaFor(variant.title);
      var imgSrc  = (meta && meta.img) || variant.image;
      var imgHTML = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + variant.title + '" loading="lazy">'
        : '';
      var badge = (meta && meta.popular)
        ? '<span class="gift-species-pop">most popular</span>'
        : '';

      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'gift-species-pill';
      pill.dataset.variantId = variant.id;
      if (meta && meta.desc) pill.dataset.desc = meta.desc;
      pill.setAttribute('aria-label', variant.title);
      pill.innerHTML =
        badge +
        '<span class="gift-species-thumb">' + imgHTML + '</span>' +
        '<span class="gift-species-label">' + variant.title + '</span>';

      grid.appendChild(pill);
    });
  }

  function updateSpeciesDesc(variantId) {
    var box = document.getElementById('gp-species-desc');
    if (!box) return;
    var grid = document.getElementById('gp-species-grid');
    var desc = '';
    if (grid && variantId) {
      var pill = grid.querySelector('.gift-species-pill[data-variant-id="' + variantId + '"]');
      if (pill) desc = pill.dataset.desc || '';
    }
    box.textContent = desc;
    box.hidden = !desc;
  }

  // ─── Render Duration List ──────────────────────────────────────────────────

  function renderDurationList(boxSize) {
    var container = document.getElementById('gp-duration-list');
    if (!container) return;
    container.innerHTML = '';

    if (!window.GIFT_PLANS_DATA || !boxSize) return;
    var data = window.GIFT_PLANS_DATA[boxSize];
    if (!data || !data.durations || !data.durations.length) return;

    var species = speciesTitleFor(boxSize, state.variantId)
      || (data.variants[0] && data.variants[0].title) || '';

    var durs = data.durations.slice().sort(function (a, b) { return a.months - b.months; });

    function variantFor(dur) {
      for (var i = 0; i < dur.variants.length; i++) {
        if (dur.variants[i].title === species) return dur.variants[i];
      }
      return null;
    }

    // Savings badge computed from real prices vs the shortest duration.
    var baseVariant = variantFor(durs[0]);
    var baseMonthly = baseVariant ? baseVariant.price : 0;

    durs.forEach(function (dur) {
      var dv = variantFor(dur);
      if (!dv) return; // species not offered for this duration

      var months     = dur.months;
      var label      = months + (months === 1 ? ' Month' : ' Months');
      var totalPrice = formatMoney(dv.price * months);
      var imgSrc     = (DURATION_IMAGES[getBoxKey(boxSize)] || {})[months];
      var savings    = (baseMonthly && dv.price < baseMonthly)
        ? Math.round((1 - dv.price / baseMonthly) * 100)
        : 0;

      var thumbHTML = imgSrc
        ? '<span class="gift-dur__thumb"><img src="' + imgSrc + '" alt="" loading="lazy"></span>'
        : '';
      var badgeHTML = savings
        ? '<span class="gift-dur__badge">save ' + savings + '%</span>'
        : '';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gift-dur';
      btn.dataset.duration = months;
      btn.setAttribute('aria-label', label);
      btn.innerHTML =
        '<span class="gift-dur__swatch" aria-hidden="true"></span>' +
        thumbHTML +
        '<span class="gift-dur__main">' +
          '<span class="gift-dur__label">' + label + '</span>' +
          '<span class="gift-dur__desc">1 box shipped monthly for ' + months + ' months • Does not renew</span>' +
        '</span>' +
        '<span class="gift-dur__r">' +
          badgeHTML +
          '<span class="gift-dur__price">' + totalPrice + '</span>' +
          '<span class="gift-dur__ship">free shipping!</span>' +
        '</span>';

      container.appendChild(btn);
    });
  }

  // ─── Submit Button ─────────────────────────────────────────────────────────

  function updateSubmitButton() {
    if (!submitBtn) return;
    submitBtn.disabled = !isFormReady();
  }

  // ─── Error Banner ──────────────────────────────────────────────────────────

  function setSubmitError(message) {
    if (!submitError) return;
    if (message) {
      submitError.textContent = message;
      submitError.removeAttribute('hidden');
    } else {
      submitError.textContent = '';
      submitError.setAttribute('hidden', '');
    }
  }

  function setSubmitLoading(loading) {
    if (!submitBtn) return;
    if (loading) {
      submitBtn.dataset.originalText = submitBtn.innerHTML;
      submitBtn.textContent = 'Adding to cart…';
      submitBtn.disabled = true;
    } else {
      if (submitBtn.dataset.originalText) submitBtn.innerHTML = submitBtn.dataset.originalText;
      submitBtn.disabled = false;
    }
  }

  // ─── Selection Helpers ─────────────────────────────────────────────────────

  function setBoxActive(boxSize) {
    var boxKey = null;
    document.querySelectorAll('.gift-box').forEach(function (card) {
      var active = card.dataset.boxSize === boxSize;
      card.classList.toggle('is-active', active);
      if (active) {
        if (card.classList.contains('gift-box--pro')) boxKey = 'pro';
        else if (card.classList.contains('gift-box--elite')) boxKey = 'elite';
        else boxKey = 'regular';
      }
    });
    // Propaga el color de la box seleccionada a los swatches de duración (CSS: [data-box] .gift-dur__swatch)
    var durList = document.getElementById('gp-duration-list');
    if (durList) {
      if (boxKey) durList.setAttribute('data-box', boxKey);
      else durList.removeAttribute('data-box');
    }
  }

  function setSpeciesActive(variantId) {
    var grid = document.getElementById('gp-species-grid');
    if (!grid) return;
    grid.querySelectorAll('.gift-species-pill').forEach(function (pill) {
      pill.classList.toggle('is-active', parseInt(pill.dataset.variantId, 10) === variantId);
    });
  }

  function setDurationActive(duration) {
    var container = document.getElementById('gp-duration-list');
    if (!container) return;
    container.querySelectorAll('.gift-dur').forEach(function (btn) {
      btn.classList.toggle('is-active', parseInt(btn.dataset.duration, 10) === duration);
    });
  }

  // ─── Data Lookup ───────────────────────────────────────────────────────────

  // Species (variant title) selected in step 2, read from the display product.
  function speciesTitleFor(boxSize, variantId) {
    var data = window.GIFT_PLANS_DATA && window.GIFT_PLANS_DATA[boxSize];
    if (!data || !data.variants) return '';
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === variantId) return data.variants[i].title;
    }
    return '';
  }

  // Resolve the purchasable variant + selling plan for box + species + duration.
  // Each duration is its own product, so the species maps across products by
  // variant title (identical within a level).
  function resolveSelection(boxSize, variantId, duration) {
    var data = window.GIFT_PLANS_DATA && window.GIFT_PLANS_DATA[boxSize];
    if (!data || !data.durations) return null;
    var species = speciesTitleFor(boxSize, variantId);
    if (!species) return null;
    for (var i = 0; i < data.durations.length; i++) {
      if (data.durations[i].months !== duration) continue;
      var dv = data.durations[i].variants || [];
      for (var j = 0; j < dv.length; j++) {
        if (dv[j].title === species) {
          return {
            variantId: dv[j].id,
            sellingPlanId: dv[j].selling_plan_id,
            monthly: dv[j].price,
            available: dv[j].available
          };
        }
      }
    }
    return null;
  }

  function isFormReady() {
    if (!state.boxSize || !state.variantId || !state.duration) return false;
    return REQUIRED_FIELDS.every(function (f) {
      return state.fields[f.key] && state.fields[f.key].trim() !== '';
    });
  }

  // ─── Validation ────────────────────────────────────────────────────────────

  function zipMatchesState(zip, stateCode) {
    if (!ZIP_REGEX.test(zip) || !stateCode) return true; // format/required checks handle these
    if (zip === '06390') return stateCode === 'NY';      // Fishers Island, NY (CT prefix)
    var ranges = ZIP_STATE_RANGES[stateCode];
    if (!ranges) return true;
    var prefix = parseInt(zip.slice(0, 3), 10);
    return ranges.some(function (r) { return prefix >= r[0] && prefix <= r[1]; });
  }

  function validateForm() {
    syncFieldsFromDOM();
    clearAllFieldErrors();
    var valid = true;

    REQUIRED_FIELDS.forEach(function (f) {
      var value = (state.fields[f.key] || '').trim();
      if (f.key === 'recipient_email') {
        // Buyers paste emails copied from links/contact cards ("mailto:x@y.com",
        // "Name <x@y.com>"). Clean it up and write it back so the cart
        // property carries a bare address (Recharge rejects anything else).
        value = cleanEmail(value);
        state.fields[f.key] = value;
        var emailEl = document.getElementById(f.domId);
        if (emailEl && emailEl.value !== value) emailEl.value = value;
        if (!EMAIL_REGEX.test(value)) { showFieldError(f.domId, f.message); valid = false; }
        return;
      }
      if (f.key === 'start_date') {
        var today = new Date(); today.setHours(0,0,0,0);
        var selected = new Date(value + 'T00:00:00');
        if (!value || selected < today) { showFieldError(f.domId, f.message); valid = false; }
        return;
      }
      if (!value) { showFieldError(f.domId, f.message); valid = false; }
    });

    // The gift email can't be later than the ship date — shipping
    // notifications would spoil the surprise.
    if (state.fields.send_gift_email !== 'no'
        && state.fields.email_date && state.fields.start_date
        && state.fields.email_date > state.fields.start_date) {
      showFieldError('gp-email-date', 'The gift email must be sent on or before the ship date.');
      valid = false;
    }

    return valid;
  }

  // ─── sessionStorage ────────────────────────────────────────────────────────

  function saveState() {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        boxSize:   state.boxSize,
        variantId: state.variantId,
        duration:  state.duration,
        fields:    state.fields
      }));
    } catch (e) {}
  }

  function restoreState() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);

      if (saved.boxSize && window.GIFT_PLANS_DATA[saved.boxSize]) {
        state.boxSize = saved.boxSize;
        setBoxActive(saved.boxSize);
        renderSpeciesGrid(saved.boxSize);
        updateGallery(saved.boxSize, null);
      }

      if (saved.variantId && state.boxSize) {
        state.variantId = saved.variantId;
        setSpeciesActive(saved.variantId);
        updateSpeciesDesc(saved.variantId);
        updateGallery(state.boxSize, saved.variantId);
        renderDurationList(state.boxSize);
      }

      if (saved.duration) {
        state.duration = saved.duration;
        setDurationActive(saved.duration);
      }

      if (saved.fields) {
        ALL_FIELDS.forEach(function (f) {
          if (saved.fields[f.key]) {
            state.fields[f.key] = saved.fields[f.key];
            var el = document.getElementById(f.domId);
            if (el) el.value = saved.fields[f.key];
          }
        });

        if (saved.fields.send_gift_email) {
          state.fields.send_gift_email = saved.fields.send_gift_email;
          var radio = document.getElementById('gp-send-email-' + saved.fields.send_gift_email);
          if (radio) radio.checked = true;
          applyEmailChoice(saved.fields.send_gift_email);
        }
      }

      updateStepStates();
      updateSummary();
      updateSubmitButton();
    } catch (e) {
      sessionStorage.removeItem(SESSION_KEY);
    }
  }

  function clearState() { sessionStorage.removeItem(SESSION_KEY); }

  // ─── Listeners ─────────────────────────────────────────────────────────────

  function attachBoxListeners() {
    document.querySelectorAll('.gift-box').forEach(function (card) {
      card.addEventListener('click', function () {
        var boxSize = card.dataset.boxSize;
        if (!boxSize || state.boxSize === boxSize) return;

        state.boxSize   = boxSize;
        state.variantId = null;
        state.duration  = null;

        setBoxActive(boxSize);
        renderSpeciesGrid(boxSize);
        renderDurationList(boxSize); // clear duration list until species picked
        updateGallery(boxSize, null);
        updateStepStates();
        updateSummary();
        updateSubmitButton();
        saveState();
      });
    });
  }

  function attachSpeciesListeners() {
    var grid = document.getElementById('gp-species-grid');
    if (!grid) return;

    grid.addEventListener('click', function (e) {
      var pill = e.target.closest('.gift-species-pill');
      if (!pill) return;

      var variantId = parseInt(pill.dataset.variantId, 10);
      if (!variantId) return;

      state.variantId = variantId;
      state.duration  = null;

      setSpeciesActive(variantId);
      updateSpeciesDesc(variantId);
      updateGallery(state.boxSize, variantId);
      renderDurationList(state.boxSize);
      updateStepStates();
      updateSummary();
      updateSubmitButton();
      saveState();

      var step3 = document.getElementById('gp-step-duration');
      if (step3) step3.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function attachDurationListeners() {
    var container = document.getElementById('gp-duration-list');
    if (!container) return;

    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.gift-dur');
      if (!btn) return;

      var duration = parseInt(btn.dataset.duration, 10);
      if (!duration) return;

      state.duration = duration;
      setDurationActive(duration);
      updateStepStates();
      updateSummary();
      updateSubmitButton();
      saveState();

      var step4 = document.getElementById('gp-step-recipient');
      if (step4) step4.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function attachFormListeners() {
    ALL_FIELDS.forEach(function (f) {
      var el = document.getElementById(f.domId);
      if (!el) return;

      // input: typing · change: selects, dates, and browser autofill ·
      // focusout: catches autofill runs that fire no events on the other fields
      var onFieldUpdate = function () {
        state.fields[f.key] = el.value;
        clearFieldError(f.domId);
        if (f.key === 'start_date') syncEmailDateLimit();
        updateStepStates();
        updateSubmitButton();
        saveState();
      };
      el.addEventListener('input', onFieldUpdate);
      el.addEventListener('change', onFieldUpdate);
      el.addEventListener('focusout', onFieldUpdate);
    });

    // Character counter
    var msgEl = document.getElementById('gp-gift-message');
    if (msgEl && charCount) {
      msgEl.addEventListener('input', function () {
        charCount.textContent = msgEl.value.length + ' / 500';
      });
    }

    // Send-gift-email Yes/No toggle
    var emailRadios = document.querySelectorAll('input[name="gp-send-email"]');
    emailRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.fields.send_gift_email = radio.value;
        applyEmailChoice(radio.value);
        saveState();
      });
    });
  }

  function applyEmailChoice(choice) {
    var field = document.getElementById('gp-email-date-field');
    if (field) field.hidden = (choice === 'no');
  }

  // The gift email must go out on or before the first shipment date: past it,
  // the automatic "Box 1 is on its way" notice would reveal the gift first.
  // (The backend also guards this for orders that slip through.)
  function syncEmailDateLimit() {
    var emailEl = document.getElementById('gp-email-date');
    if (!emailEl) return;
    var startVal = state.fields.start_date || '';
    if (!startVal) return;

    emailEl.setAttribute('max', startVal);
    if (emailEl.value && emailEl.value > startVal) {
      emailEl.value = startVal;
      state.fields.email_date = startVal;
      showFieldError('gp-email-date', 'Adjusted: the gift email must be sent on or before the ship date, so the surprise isn\'t spoiled by shipping notifications.');
      saveState();
    }
  }

  function attachSubmitListener() {
    if (!submitBtn) return;

    submitBtn.addEventListener('click', function () {
      setSubmitError(null);

      if (!validateForm()) {
        var firstError = document.querySelector('.gift-input--error, .gift-select--error');
        if (firstError) { firstError.scrollIntoView({ behavior: 'smooth', block: 'center' }); firstError.focus(); }
        return;
      }

      if (!state.variantId) { setSubmitError('Please select a species type.'); return; }

      var sel = resolveSelection(state.boxSize, state.variantId, state.duration);
      if (!sel) { setSubmitError('This combination is unavailable. Please pick a different duration.'); return; }
      addToCart(sel.variantId, sel.sellingPlanId);
    });
  }

  // ─── Add to Cart ───────────────────────────────────────────────────────────

  // Storefront API (public token — safe for client-side use). Used to create
  // the gift cart with the recipient's address preloaded into checkout via
  // deliveryAddressPreferences; the old checkout[...] query params are ignored
  // by Shopify's current checkout.
  var STOREFRONT_API_URL = '/api/2024-10/graphql.json';
  var STOREFRONT_TOKEN   = '17ac409f0428a4e4a54b2f3d363de5dd';

  // Name split mirrors the backend parser: first word = first name,
  // rest = last name (falls back to first name).
  function splitRecipientName() {
    var nameParts = (state.fields.recipient_name || '').trim().split(/\s+/);
    var firstName = nameParts[0] || '';
    return { firstName: firstName, lastName: nameParts.slice(1).join(' ') || firstName };
  }

  // Leading underscore = hidden from cart/checkout, still sent to the order + webhook.
  function giftProperties() {
    return {
      _gift_subscription: 'true',
      _box_size:          state.boxSize,
      _duration:          String(state.duration),
      _recipient_name:    state.fields.recipient_name,
      _recipient_email:   state.fields.recipient_email,
      // Address is NOT sent as attributes anymore: the backend reads it from
      // the order's shipping address, which the buyer enters in checkout.
      _start_date:        state.fields.start_date,
      _send_gift_email:   state.fields.send_gift_email || 'yes',
      _email_date:        (state.fields.send_gift_email === 'no') ? '' : (state.fields.email_date || ''),
      _gift_message:      state.fields.gift_message
    };
  }

  // Creates a standalone Storefront API cart (separate from the theme cart)
  // with the gift line + recipient address preference, and resolves with its
  // checkout URL. Rejects on any API/user error so the caller can fall back.
  function createPrefilledCart(variantId, sellingPlanId, properties) {
    var attributes = Object.keys(properties)
      .map(function (key) { return { key: key, value: String(properties[key] == null ? '' : properties[key]) }; })
      .filter(function (a) { return a.value !== ''; });

    var line = {
      merchandiseId: 'gid://shopify/ProductVariant/' + variantId,
      quantity: 1,
      attributes: attributes
    };
    if (sellingPlanId) line.sellingPlanId = 'gid://shopify/SellingPlan/' + sellingPlanId;

    // Only the recipient's NAME is preloaded into the checkout address form;
    // the street address itself is typed there by the buyer (single capture).
    var name = splitRecipientName();
    var input = {
      lines: [line],
      buyerIdentity: {
        countryCode: 'US',
        deliveryAddressPreferences: [{
          deliveryAddress: {
            firstName: name.firstName,
            lastName:  name.lastName,
            country:   'US'
          }
        }]
      }
    };

    var query = 'mutation cartCreate($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } } }';

    return fetch(STOREFRONT_API_URL, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: query, variables: { input: input } })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var result = data && data.data && data.data.cartCreate;
        if (!result || !result.cart || !result.cart.checkoutUrl ||
            (result.userErrors && result.userErrors.length)) {
          throw new Error('cartCreate failed');
        }
        return result.cart.checkoutUrl;
      });
  }

  // Fallback: theme Ajax cart + plain checkout (no address prefill).
  function legacyAddToCart(variantId, sellingPlanId, properties) {
    var payload = { id: variantId, quantity: 1, properties: properties };
    if (sellingPlanId) payload.selling_plan = sellingPlanId;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
        return res.json();
      })
      .then(function () {
        clearState();
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        setSubmitLoading(false);
        setSubmitError(err.message || 'Something went wrong. Please try again.');
      });
  }

  function addToCart(variantId, sellingPlanId) {
    setSubmitLoading(true);
    var properties = giftProperties();

    createPrefilledCart(variantId, sellingPlanId, properties)
      .then(function (checkoutUrl) {
        clearState();
        window.location.href = checkoutUrl;
      })
      .catch(function () {
        legacyAddToCart(variantId, sellingPlanId, properties);
      });
  }

  // ─── Init ──────────────────────────────────────────────────────────────────

  function init() {
    if (!window.GIFT_PLANS_DATA) {
      console.error('[Gift Plans] window.GIFT_PLANS_DATA is not defined.');
      return;
    }

    // Set min date to today
    var dateInput = document.getElementById('gp-start-date');
    if (dateInput) dateInput.setAttribute('min', new Date().toISOString().split('T')[0]);

    // Gift email date: today up to one year from now
    var emailDateInput = document.getElementById('gp-email-date');
    if (emailDateInput) {
      var today = new Date();
      emailDateInput.setAttribute('min', today.toISOString().split('T')[0]);
      var maxDate = new Date(today);
      maxDate.setFullYear(maxDate.getFullYear() + 1);
      emailDateInput.setAttribute('max', maxDate.toISOString().split('T')[0]);
    }

    updateStepStates();
    restoreState();
    syncEmailDateLimit();

    attachBoxListeners();
    attachSpeciesListeners();
    attachDurationListeners();
    attachFormListeners();
    attachSubmitListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
